
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91slug_930GqRg_45URxZnrbZhQR1HdrptjGhpkIM9RWyzbD3F8irkMeta } from "/app/pages/[slug].vue?macro=true";
import { default as _91faq_93Op8COpLblb2ckBUit9mk53yl4WeASZvj5ZtQyncmTskMeta } from "/app/pages/faq/[faq].vue?macro=true";
import { default as indexnmtc_CRIGMl8bQY8kcWfHZPoBfSC_45Fn0SKIBIlRgAJgMeta } from "/app/pages/faq/index.vue?macro=true";
import { default as indexgXAvaMPwKrurPyfrnchlOoI4Og1SV7Q_45uxSxTgQKpqEMeta } from "/app/pages/cart/index.vue?macro=true";
import { default as test_45webviewkgWwqy4hAhH0W87lg8kFOZH_DwYRODRSiiFk_qHSsrIMeta } from "/app/pages/test-webview.vue?macro=true";
import { default as indexKGFpJrfaPGuuhppiHh6jzgX1cc0MaKSlIxKJ_45q3hxrYMeta } from "/app/pages/account/index.vue?macro=true";
import { default as test_45redirectD0ci2O2cEMnEmWhmltDwyAbSlA7YE_45xUuoVsyoOIYisMeta } from "/app/pages/test-redirect.vue?macro=true";
import { default as indexeqrhb3wO_45xZAJRRupU_45HmB9W_454nOdJG2hViYjPL9v7kMeta } from "/app/pages/about-us/index.vue?macro=true";
import { default as index7PHmsvhFvB_g5kZxgiuxoeT0bdw2nPdkEwlj4tb_456q4Meta } from "/app/pages/checkout/index.vue?macro=true";
import { default as _91slug_93XzqoVhZIAOhjJjvlEf2fBP4m41uqcwER614gBbwGt38Meta } from "/app/pages/product/[slug].vue?macro=true";
import { default as indexrkqoVXCTXog36l5mcWMcImfXw7hnzoJicoPtl_45_45A3sEMeta } from "/app/pages/recharge/index.vue?macro=true";
import { default as index_45px2aQE68polVw5KH8ySfd_45aZRc0_bG19_45Kqjvc1V2AMeta } from "/app/pages/web-chat/index.vue?macro=true";
import { default as forget_45passwordb_9cvKV7RLpfuojGUieffZXS1xNS1q4kTjmk12b9LWAMeta } from "/app/pages/forget-password.vue?macro=true";
import { default as indexBKL_45vhN7r1HRlwzWv5q2JEjo6Jiz5fi_gnpzXdrHrGQMeta } from "/app/pages/outage-map/index.vue?macro=true";
import { default as test_45auth_45statusbfj6e7nr0XEbJoeCtLY_45swKRW86aCdQR0q3y5FugGTQMeta } from "/app/pages/test-auth-status.vue?macro=true";
import { default as dashboardtK0ozZhMYhXnncQ3sPTlwjI3OZxF0srgQvD0oGApcOQMeta } from "/app/pages/account/dashboard.vue?macro=true";
import { default as indexXNhDBDuFCWdgpSupCrQJKN97NQd4Pwka8J_WFg7JjUkMeta } from "/app/pages/extra-packs/index.vue?macro=true";
import { default as biometricsCxXqMoNPtVnWplsU7efE_45LL6k8DAEmtchRH8jm4tf6IMeta } from "/app/pages/account/biometrics.vue?macro=true";
import { default as indexkPB5H1dqAAd0x13eohVa0_45ZM5ozEtyQ7ZQbXmDKOjPUMeta } from "/app/pages/mobile-plans/index.vue?macro=true";
import { default as verificationa2f_NJ3tgcMh5W1QzS_45HBPiLIBfnhIaFnbJ_45LtGQA3UMeta } from "/app/pages/account/verification.vue?macro=true";
import { default as indexaPJ8Odk51PF6LXtnaofkB_45Xg5L2QjT09xe5SNz_45TaUsMeta } from "/app/pages/sim-activation/index.vue?macro=true";
import { default as confirmationq_45o8NMQlNsiBxNMdGNJoW0_45NsiDHlc8E6rKq03HIuFQMeta } from "/app/pages/checkout/confirmation.vue?macro=true";
import { default as index7jApMTEdc4d9CqxuIYEfX6n2SF9QV2vJusptBg4xE9sMeta } from "/app/pages/network-coverage/index.vue?macro=true";
import { default as indexqfV6l86BethNy_nEXPUrF_mWDuI65h7OV5JsrOSiExEMeta } from "/app/pages/payment-new-card/index.vue?macro=true";
import { default as indexpNmP2RtY6rHbYRdIQ571RFXXj0ImkTTovX_45j_qEayxgMeta } from "/app/pages/pages/email-changed/index.vue?macro=true";
import { default as indexuCfm5nVnzbn31yJf6FE31ut2zflAM3u7yCv0OyhxCMEMeta } from "/app/pages/pages/reset-password/index.vue?macro=true";
import { default as index9zzk0xN9_LPobp0GmA0mwgGj4NQCdv_YGI1_VqaGpVgMeta } from "/app/pages/pages/email-confirmed/index.vue?macro=true";
import { default as verification_45refactoredkBGi169XHccUQVeraORIrfi_xWbVqg8neyOHEj5ibxcMeta } from "/app/pages/test/verification-refactored.vue?macro=true";
import { default as _91token_93n3uiulU6D_453glBWYbJV1QOoIHohqGY8_dXEA9mg7QHMMeta } from "/app/pages/marketing/unsubscribe/[token].vue?macro=true";
import { default as verification_45buttons_45testyzT7V4P_45LfvOummdCLC5bN3JVxquRl9xeIghuvCLuDAMeta } from "/app/pages/test/verification-buttons-test.vue?macro=true";
import { default as _91token_93gk_45JD5tFmEYm_Ll_T5wf5rLpulBdGxo0bFztS6Mky3sMeta } from "/app/pages/pages/hrt-authenticator/[token].vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/app/pages/[slug].vue")
  },
  {
    name: "faq-faq",
    path: "/faq/:faq()",
    component: () => import("/app/pages/faq/[faq].vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/app/pages/faq/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/app/pages/cart/index.vue")
  },
  {
    name: "test-webview",
    path: "/test-webview",
    meta: test_45webviewkgWwqy4hAhH0W87lg8kFOZH_DwYRODRSiiFk_qHSsrIMeta || {},
    component: () => import("/app/pages/test-webview.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "test-redirect",
    path: "/test-redirect",
    component: () => import("/app/pages/test-redirect.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/app/pages/about-us/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/app/pages/checkout/index.vue")
  },
  {
    name: "product-slug",
    path: "/product/:slug()",
    component: () => import("/app/pages/product/[slug].vue")
  },
  {
    name: "recharge",
    path: "/recharge",
    component: () => import("/app/pages/recharge/index.vue")
  },
  {
    name: "web-chat",
    path: "/web-chat",
    component: () => import("/app/pages/web-chat/index.vue")
  },
  {
    name: "forget-password",
    path: "/forget-password",
    component: () => import("/app/pages/forget-password.vue")
  },
  {
    name: "outage-map",
    path: "/outage-map",
    component: () => import("/app/pages/outage-map/index.vue")
  },
  {
    name: "test-auth-status",
    path: "/test-auth-status",
    component: () => import("/app/pages/test-auth-status.vue")
  },
  {
    name: "account-dashboard",
    path: "/account/dashboard",
    component: () => import("/app/pages/account/dashboard.vue")
  },
  {
    name: "extra-packs",
    path: "/extra-packs",
    component: () => import("/app/pages/extra-packs/index.vue")
  },
  {
    name: "account-biometrics",
    path: "/account/biometrics",
    component: () => import("/app/pages/account/biometrics.vue")
  },
  {
    name: "mobile-plans",
    path: "/mobile-plans",
    component: () => import("/app/pages/mobile-plans/index.vue")
  },
  {
    name: "account-verification",
    path: "/account/verification",
    component: () => import("/app/pages/account/verification.vue")
  },
  {
    name: "sim-activation",
    path: "/sim-activation",
    component: () => import("/app/pages/sim-activation/index.vue")
  },
  {
    name: "checkout-confirmation",
    path: "/checkout/confirmation",
    component: () => import("/app/pages/checkout/confirmation.vue")
  },
  {
    name: "network-coverage",
    path: "/network-coverage",
    component: () => import("/app/pages/network-coverage/index.vue")
  },
  {
    name: "payment-new-card",
    path: "/payment-new-card",
    component: () => import("/app/pages/payment-new-card/index.vue")
  },
  {
    name: "pages-email-changed",
    path: "/pages/email-changed",
    component: () => import("/app/pages/pages/email-changed/index.vue")
  },
  {
    name: "pages-reset-password",
    path: "/pages/reset-password",
    component: () => import("/app/pages/pages/reset-password/index.vue")
  },
  {
    name: "pages-email-confirmed",
    path: "/pages/email-confirmed",
    component: () => import("/app/pages/pages/email-confirmed/index.vue")
  },
  {
    name: "test-verification-refactored",
    path: "/test/verification-refactored",
    component: () => import("/app/pages/test/verification-refactored.vue")
  },
  {
    name: "marketing-unsubscribe-token",
    path: "/marketing/unsubscribe/:token()",
    component: () => import("/app/pages/marketing/unsubscribe/[token].vue")
  },
  {
    name: "test-verification-buttons-test",
    path: "/test/verification-buttons-test",
    component: () => import("/app/pages/test/verification-buttons-test.vue")
  },
  {
    name: "pages-hrt-authenticator-token",
    path: "/pages/hrt-authenticator/:token()",
    component: () => import("/app/pages/pages/hrt-authenticator/[token].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/api/v1/ui/register/Email-Confirmation",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/api/v1/rest/customer/update-email",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/home/page/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/faqs",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/faqs/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/support",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]